/**
 * This is lazy loading config that initiate when open the webpage
 * DON'T import any module here. Ohterwise, the module will be loaded and lost the lazy loading.
 * */

import { withAsync } from '../../components/lazyLoading/async-component';

const MODULE_FOLDER_NAME = '_lazy-sample'; // Folder name of the module for lazy import
const MODULE_NAME = 'hk-emma-web-module-lazy-sample'; // Module name from package.json
const ROOT_PATHS = ['lazy/sample']; // Root path of the routes

export default {
  /**
    preloadModules: [
      {
        moduleName: MODULE_NAME,
        moduleFolderNames: [MODULE_FOLDER_NAME],
        preloadReducers: {
          'sampleReducer': {
            reducer: sampleReducer
          }
        },
        preloadSagas: [sampleSaga]
      },
    ],
  */
  modules: [
    {
      moduleName: MODULE_NAME,
      routes: {
        rootPaths: ROOT_PATHS,
        subPaths: {
          '/': {
            exact: true,
            // Turn enableMobileRoute on if you want to access it by mobile via '/en/emma/lazy/sample' without profile-api dependency
            enableMobileRoute: true,
            container: withAsync(MODULE_FOLDER_NAME, '/'),
          },
        },
      },
    },
  ],
};
